;(function($){

    function Contact() {
        var _ = this;

        var $formContact = $("#form-newsletter").validate({
            rules: {
                email: { required: true, email: true },
            },
            messages: {
                email: { required: 'Informe o seu email', email: 'Ops, informe um email válido' },
            },
            invalidHandler: function(e) {
                swal({
                    title: "OPS! Você não preencheu todos os campos!",
                    text: "Preencha todos os campos e tente novamente.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK!",
                    closeOnConfirm: true
                });

            },
            submitHandler: function( form ) {

                var myform = $(form).serialize();
                
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: $("#app_url").val() + "/api/newsletters",
                    data: myform,
                    success: function(result)
                    {
                        swal({
                            title: result.message,
                            text: "Click no botão para fechar!",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: true
                        });

                        form.reset();
                        grecaptcha.reset();
                    },
                    error: function(response) {
                        var text = $.parseJSON(response.responseText);
                        
                        swal({
                            title: (text.error) ? text.error : "Ops! Houve um erro ao enviar. Tente novamente.",
                            text: "Click no botão para fechar!",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: true
                        });
                        
                    }
                });
            }
        });

    }

    new Contact();

}(jQuery));
 
 
